import { type FC, type Dispatch, type SetStateAction } from "react";
import "react-calendar/dist/Calendar.css";
import { useRequest } from "../../contexts/RequestProvider";

import { type RequestType } from "@entities";
import { Stack } from "@mui/material";
import { DetailsSection } from "./DetailsSection";
import type { OrganizationRequestSaveResult } from "./OrganizationRequest";

export type FormFields = RequestType;

interface OrganizationRequestMainSectionProps {
  isEdit?: boolean;
  isEventCard?: boolean;
  showExtendedLayout?: boolean;
  isStandalonePage?: boolean;
  setIsAddEvent?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsAddAidRelated?: Dispatch<SetStateAction<boolean>>;
  onSaveSuccess?: (result?: OrganizationRequestSaveResult) => void;
}

export const OrganizationRequestMainSection: FC<
  OrganizationRequestMainSectionProps
> = ({
  isEdit,
  showExtendedLayout,
  isStandalonePage,
  setIsAddEvent,
  setIsAddAidRelated = () => {},
  onSaveSuccess,
}) => {
  const { currentEvent: requestDetails } = useRequest();

  return (
    <Stack
      className="organization-request"
      flex={showExtendedLayout ? "1 1 55%" : 1}
      sx={{ direction: "rtl", minWidth: 0, minHeight: 0 }}
      gap={2}
      width="100%"
      height="100%"
      alignItems="stretch"
    >
      <DetailsSection
        setIsAddEvent={setIsAddEvent}
        isEdit={isEdit}
        requestDetails={requestDetails}
        showExtendedLayout={showExtendedLayout}
        isStandalonePage={isStandalonePage}
        onSaveSuccess={onSaveSuccess}
        setIsAddAidRelated={setIsAddAidRelated}
      />
    </Stack>
  );
};

export default OrganizationRequestMainSection;
